import httpHelper from "../helpers/http_helper";

const notificationService = {
    list: async function (data) {
        return await httpHelper.post("/RestApi/Service/Notifications", data || {});
    },
    deleteNotification: async function (ids) {
        return await httpHelper.post("/RestApi/Service/DeleteNotification", {
            notifyIds: JSON.stringify(ids)
        });
    },
    async read(idNotify) {
        return await httpHelper.post("/RestApi/Service/DeleteNotification", {
            idNotify
        });
    }
}

export default notificationService;